export function useItemTipo() {
  const itemTipos = ['Materia Prima', 'Producto Terminado', 'Servicio'];

  return {
    itemTipos,
  };
}
